'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DATA = exports.DATA = ['data'];
var STATUS = exports.STATUS = ['status'];